import { Table, TableBody, TableCell, TableHead } from '@mui/material'
import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { get } from '../helpers/Api'
import LoadingIndicator from '../loadingindicator'
import MarketRankingElement from './MarketRankingElement'
import StatsElement from './StatsElement'

function TopMarkets(props) {
    const [chartRange, setChartRange] = useState(1)
    const [revenueHistory, setRevenueHistory] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const searchAuthor = props['searchAuthor']
    const { t } = useTranslation('common')

    const [volumeType, setVolumeType] = useState('all')

    const textClass = cn('px-2 py-4')

    useEffect(() => {
        GetRevenueHistory(chartRange, searchAuthor, volumeType)
    }, [chartRange, searchAuthor, volumeType])

    const selectVolumeType = (target) => {
        setVolumeType(target)
    }

    const GetRevenueHistory = async (range, author, type) => {
        setIsLoading(true)

        await get(
            `top-markets/${range}?type=${type}${
                author ? '&author=' + author : ''
            }`,
            'v3',
        ).then(setRevenueHistory)

        setIsLoading(false)
    }

    const chartDropDownOptions = [
        { value: 1, label: t('analytics.24h_market_volume') },
        { value: 2, label: t('analytics.days_market_volume', { days: 2 }) },
        { value: 3, label: t('analytics.days_market_volume', { days: 3 }) },
        { value: 7, label: t('analytics.days_market_volume', { days: 7 }) },
        { value: 15, label: t('analytics.days_market_volume', { days: 15 }) },
        { value: 30, label: t('analytics.days_market_volume', { days: 30 }) },
        { value: 60, label: t('analytics.days_market_volume', { days: 60 }) },
        { value: 90, label: t('analytics.days_market_volume', { days: 90 }) },
        { value: 180, label: t('analytics.days_market_volume', { days: 180 }) },
        { value: 365, label: t('analytics.days_market_volume', { days: 365 }) },
        { value: 0, label: t('analytics.all_time_market_volume') },
    ]

    const onSelectChartRange = (e) => {
        if (e.target.value !== chartRange) setChartRange(e.target.value)
    }

    return (
        <div className="h-auto w-auto overflow-y-auto dark:text-white text-black">
            <StatsElement
                title={''}
                chartRange={chartRange}
                onChange={onSelectChartRange}
                chartDropDownOptions={chartDropDownOptions}
                volumeType={volumeType}
                selectVolumeType={selectVolumeType}
            >
                {isLoading ? (
                    <LoadingIndicator />
                ) : (
                    <div className="relative w-full mb-auto">
                        <Table size="small" sx={{ width: '100%' }}>
                            <TableHead>
                                <TableCell />
                                <TableCell>{t('landing.name_col')}</TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-middle')}
                                >
                                    {t('landing.volume_wax_col')}
                                </TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-middle')}
                                >
                                    {t('landing.volume_usd_col')}
                                </TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-right')}
                                >
                                    {t('landing.change_col')}
                                </TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-right')}
                                >
                                    {t('analytics.buyers')}
                                </TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-right')}
                                >
                                    {t('analytics.sellers')}
                                </TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-right')}
                                >
                                    {t('landing.sales_col')}
                                </TableCell>
                            </TableHead>
                            <TableBody className="overflow-y-auto">
                                {revenueHistory &&
                                    revenueHistory.map((volume, index) => (
                                        <MarketRankingElement
                                            key={
                                                'CollectionRankingElement-' +
                                                index
                                            }
                                            volume={volume}
                                            index={index}
                                        />
                                    ))}
                            </TableBody>
                        </Table>
                    </div>
                )}
            </StatsElement>
        </div>
    )
}

export default TopMarkets
